module.exports = __webpack_public_path__ + "img/serveContent3.17e5866c.png";